var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7781 1.66699C12.34 1.66699 11.9845 2.02255 11.9845 2.46064C11.9845 2.89874 12.34 3.25429 12.7781 3.25429H15.6241L9.04236 9.83602C8.73244 10.1459 8.73244 10.6484 9.04236 10.9583C9.19752 11.1134 9.40033 11.1908 9.6035 11.1908C9.80668 11.1908 10.0095 11.1134 10.1646 10.9583L16.7464 4.37657V7.22255C16.7464 7.66064 17.1019 8.0162 17.54 8.0162C17.9781 8.0162 18.3337 7.66064 18.3337 7.22255V2.46064C18.3337 2.02255 17.9781 1.66699 17.54 1.66699H12.7781ZM4.04794 2.46064C2.73485 2.46064 1.66699 3.5285 1.66699 4.8416V15.9527C1.66699 17.2658 2.73485 18.3337 4.04794 18.3337H15.1591C16.4722 18.3337 17.54 17.2658 17.54 15.9527V11.1908C17.54 10.7527 17.1845 10.3972 16.7464 10.3972C16.3083 10.3972 15.9527 10.7527 15.9527 11.1908V15.9527C15.9527 16.3904 15.5968 16.7464 15.1591 16.7464H4.04794C3.61025 16.7464 3.25429 16.3904 3.25429 15.9527V4.8416C3.25429 4.4039 3.61025 4.04794 4.04794 4.04794H8.80985C9.24795 4.04794 9.6035 3.69239 9.6035 3.25429C9.6035 2.8162 9.24795 2.46064 8.80985 2.46064H4.04794Z",
    fill: "#03F5AE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkGreen);
export default __webpack_public_path__ + "static/media/link-green.8997d55b8c475efb61e2ab08896ff787.svg";
export { ForwardRef as ReactComponent };